import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useResource, Resources } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import { NotificationsList } from "Components/Shared/Notification/NotificationsList";

export const NotificationsPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.Notifications)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("dashboard"),
      }}
    >
      <StyledPageWrapper>
        <div className="left-content">
          <NotificationsList isReadOnly />
        </div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
